import React from 'react';
import CsvParse from 'papaparse';
import { UploadFileStep } from './steps/UploadFileStep';
import { ReviewStep } from './steps/ReviewStep';
import { ImportedStep } from './steps/ImportedStep';
import { useEndpointFetch } from '../../../global/network/useEndpointFetch';

type CompletedTaskImportType = {
  profileId: string;
  taskId: string;
  fieldValues: Record<string, string>;
};

export function ImportingTaskDataScreen() {
  const [step, setStep] = React.useState<number>(0);
  const [uploadingFile, setUploadingFile] = React.useState<File>();
  const [fileData, setFileData] = React.useState<any>([]);
  const [importedData, setImportedData] = React.useState<any>();
  const [isImporting, setIsImporting] = React.useState(false);

  const onNext = () => setStep((currentStep) => currentStep + 1);
  const onBack = () => setStep((currentStep) => Math.max(0, currentStep - 1));

  const importTasks = useEndpointFetch<{ completedTasks: CompletedTaskImportType[] }, any>(
    '/vm/volunteer/profile/completed-task/import-bulk'
  );

  const onImport = (importData: any) => {
    setIsImporting(true);
    onNext();
    importTasks
      .run({
        completedTasks: importData,
      })
      .then((response) => {
        setImportedData(response);
        setIsImporting(false);
      })
      .catch(() => {
        setIsImporting(false);
      });
  };

  React.useEffect(() => {
    if (!uploadingFile) {
      return;
    }
    CsvParse.parse(uploadingFile, {
      header: true,
      skipEmptyLines: true,
      complete: (csvData: any) => {
        setFileData(csvData.data);
      },
    });
  }, [uploadingFile]);

  switch (step) {
    case 0:
      return <UploadFileStep onNext={onNext} onUpload={setUploadingFile} uploadingFile={uploadingFile} />;

    case 1:
      return (
        <ReviewStep
          onImport={onImport}
          onBack={onBack}
          data={fileData}
          setData={setFileData}
          isImporting={isImporting}
        />
      );

    case 2:
      return (
        <ImportedStep
          data={importedData?.data?.data}
          onBack={() => setStep(1)}
          onComplete={() => setStep(0)}
          isImporting={isImporting}
        />
      );
    default:
      return null;
  }
}
